import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      d: "m7.825 13 4.9 4.9q.3.3.288.7t-.313.7q-.3.275-.7.288a.91.91 0 0 1-.7-.288l-6.6-6.6a.9.9 0 0 1-.213-.325A1.1 1.1 0 0 1 4.425 12a1.1 1.1 0 0 1 .063-.375.9.9 0 0 1 .212-.325l6.6-6.6a.93.93 0 0 1 .688-.275q.413 0 .712.275.3.3.3.713a.97.97 0 0 1-.3.712L7.825 11H19q.425 0 .713.288T20 12a.97.97 0 0 1-.288.713A.96.96 0 0 1 19 13z"
    }, null, -1)
  ]))]))
}
export default { render: render }